module.exports = __webpack_public_path__ + "static/img/7833_phase_function_Paper_Points.5a07e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7833_phase_function_Paper_Points.png
// module id = 1Fp5
// module chunks = 0